import { Button, message, Space, Table } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "@server";
import { userVidRender } from "@extensions/enums";
import { deleteButton } from "@extensions/design";
import CompanyUser from "./company-user";

const CompanyUsers = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);

  const getData = () => {
    setLoading(true);    
    serverFetch(`user`)
      .then(data => {
        setLoading(false);
        setItems(data);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, []);

  const onDelete = record => {
    setLoading(true);
    serverFetch(`user?vid=${encodeURIComponent(record.vid)}&name=${encodeURIComponent(record.name)}`, { method: "DELETE" })
      .then(() => getData())
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  }

  const onCreate = () => setSelected({vid: 2, name: ""});

  const columns = [
    { dataIndex: "vid", title: "Вид", render: userVidRender },
    { dataIndex: "name", title: "Пользователь"},
    { 
      title: "", 
      render: (_, record) => (
        <div className="actions-on-hover">
          {deleteButton(loading, record.name, () => onDelete(record))}
        </div>
      ),
    },
  ]

  const onItemClose = refresh => {
    setSelected(null);
    if (refresh) getData();
  }

  return <div>
    <Space>
      <Button onClick={onCreate} type="primary">Создать</Button>
      <Button onClick={getData} type="primary">Обновить</Button>
    </Space>
    <Table
      dataSource={items}
      loading={loading}
      columns={columns}
      pagination={false}
      size="small"
      rowKey="name"
    />
    {selected && <CompanyUser onClose={onItemClose} itemDefault={selected} />}
  </div>
}

export default CompanyUsers;

